import { render } from "./IndexV2.vue?vue&type=template&id=b66f3ca6"
import script from "./IndexV2.vue?vue&type=script&lang=js"
export * from "./IndexV2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__